
import lodash from 'lodash'

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

export const debounce = (fn, wait = 500) => {
    let timer
    return function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
            fn.call(this, ...arguments)
        }, wait)
    }
}

export function isFunction(functionToCheck) {
    const getType = {}
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]'
}


export const numberComplete = (str) => {
    if (str === undefined || str === null) return
    let newStr = ''
    str = String(lodash.round(str, 2))
    let parts = str.split('.');
    let decPart = parts[1] || '';
    if (decPart.length === 0) {
      decPart = '00';
    } else if (decPart.length === 1) {
      decPart += '0';
    } else {
      decPart = decPart.substr(0, 2);
    }
  
    // 当数字是整数
    if (str.indexOf('.') === -1) {
      return newStr == 0 ? (parts[0] + '.' + decPart) : newStr
    } else {
      str = parts[0] + (str + '00').substr((str + '00').indexOf('.'), 3)
      return str
    }
  }